var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ejs-toast',{ref:"notifierToastRef",attrs:{"id":"notifierToast","show-close-button":true,"time-out":0,"animation":_vm.displayAnimation,"position":_vm.toastPosition,"click":_vm.onToastClick}})}
var staticRenderFns = []

export { render, staticRenderFns }